import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsHusqvarnaComponent } from './simple-icons-husqvarna.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsHusqvarnaComponent ],
    exports:      [ SimpleIconsHusqvarnaComponent ],
    bootstrap:    []
})
export class SimpleIconsHusqvarnaModule {}
